<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import TransporterVehicles from "./TransporterVehicles.svelte";
    import TransporterDrivers from "./TransporterDrivers.svelte";
    import TransporterUsers from "./TransporterUsers.svelte";
    import VehicleEdit from "../vehicles/VehicleEdit.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import {setFocusTo, getIdFromUrl, copyObjectData, scrollTo} from "../lib/lib";

    export let transporterId = null;
    export let changeCallback;

    let breadcrumb = [
        {id: 'transporters', name: 'Transporters', link: `/app/transporter`}
    ];

    let transporter = null;
    let pageTitle = '';
    let vehicleId = null;

    const initialize = () => {
        if (transporterId == 0 || transporterId == 'create') {
            transporter = {
                id: 0,
                name: '',
                contact_person: '',
                address: '',
                phone: '',
                mobile: '',
                email: '',
                vat: '',
                tax_office: '',
                notes: '',
                is_active: 1,
                vehicles: [],
                drivers: [],
            };
            transporterId = 0;
            pageTitle = "New Transport Company";
            setFocusTo('transporterName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            transporter = result;
            pageTitle = result.name;

            vehicleId = getIdFromUrl('vehicle');
            if (!vehicleId) {
                setFocusTo('transporterName');
            }
        }

        const onFailure = err => {
            transporterId = -1;
        };

        R.handle(R.transporter.details, transporterId, onSuccess, onFailure, LOADER.PAGE);
    };

    const save = () => {
        const onSuccess = result => {
            transporter = result;
            transporterId = result.id;
            pageTitle = result.name;
            changeCallback(transporter);
            Notifier.showMessage("Transport company saved");
        }

        const onFailure = err => {
            Alert.warning("Transporter", err.message);
        };

        transporter.name = transporter.name.trim();
        if (!transporter.name) {
            Notifier.showError("Type the name of the transport company!");
            setFocusTo('transporterName');
            return;
        }

        let action = transporter.id === 0 ? 'create' : 'edit';
        R.handle(R.transporter[action], transporter, onSuccess, onFailure, LOADER.POPUP);
    }

    const onCreateVehicle = () => {
        vehicleId = 0;
        router.go(`/app/transporter/${transporterId}/vehicle/create`)();
    }

    const onEditVehicle = ({detail: id}) => {
        vehicleId = id;
        router.go(`/app/transporter/${transporterId}/vehicle/${id}`)();
    }

    const updateVehicle = (vehicle) => {
        console.log("updateVehicle", vehicle);
        if (!vehicle) {
            backToTransporter();
        } else {
            let item = transporter.vehicles.find(x => x.id == vehicle.id);
            if (item) {
                copyObjectData(vehicle, item);
                transporter.vehicles = transporter.vehicles;
            } else {
                transporter.vehicles = [vehicle, ...transporter.vehicles];
            }
        }
    }

    const backToTransporter = () => {
        breadcrumb = breadcrumb.filter(x => x.id === 'transporters');
        vehicleId = null;
        scrollTo('top');
        router.go(`/app/transporter/${transporterId}`)();
    }

    initialize();
</script>

<Breadcrumb {breadcrumb} on:transporter="{ backToTransporter }"/>
{#if transporter}
    {#if vehicleId != null}
        <VehicleEdit { vehicleId } {transporter} bind:breadcrumb={ breadcrumb } changeCallback="{ updateVehicle }"/>
    {:else}
        <PageHeader title="{ pageTitle }"/>
        <div class="row">
            <div class="col-xl-6 col-lg-7 col-md-6">
                <div class="panel border-default mb-5">
                    <div class="panel-body panel-pad">
                        <form autocomplete="off">
                            <div class="form-group">
                                <h5>Company name</h5>
                                <input type="text" class="form-control" id="transporterName"
                                       bind:value="{ transporter.name }" autocomplete="off">
                            </div>
                            <div class="row">
                                <div class="col-xl-6">
                                    <div class="form-group">
                                        <label>Contact person</label>
                                        <input type="text" class="form-control"
                                               bind:value="{ transporter.contact_person }"
                                               autocomplete="off">
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12 col-lg-6">
                                            <div class="form-group">
                                                <label>Phone</label>
                                                <input type="tel" class="form-control"
                                                       bind:value="{ transporter.phone }"
                                                       autocomplete="off">
                                            </div>
                                        </div>
                                        <div class="col-xl-12 col-lg-6">
                                            <div class="form-group">
                                                <label>Mobile</label>
                                                <input type="tel" class="form-control"
                                                       bind:value="{ transporter.mobile }"
                                                       autocomplete="off">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="email" class="form-control" bind:value="{ transporter.email }"
                                               autocomplete="off">
                                    </div>
                                </div>
                                <div class="col-xl-6">
                                    <hr class="hidden-xl">
                                    <div class="form-group">
                                        <label>Address</label>
                                        <input type="text" class="form-control" bind:value="{ transporter.address }"
                                               autocomplete="off">
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12 col-lg-6">
                                            <div class="form-group">
                                                <label>Vat</label>
                                                <input type="text" class="form-control" bind:value="{ transporter.vat }"
                                                       autocomplete="off">
                                            </div>
                                        </div>
                                        <div class="col-xl-12 col-lg-6">
                                            <div class="form-group">
                                                <label>Tax Office</label>
                                                <input type="text" class="form-control"
                                                       bind:value="{ transporter.tax_office }"
                                                       autocomplete="off">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="form-group">
                                <label>Notes</label>
                                <textarea class="form-control" bind:value="{ transporter.notes }"></textarea>
                            </div>
                            <div class="form-group">
                                <Checkbox label="Active transporter" bind:checked={ transporter.is_active }/>
                            </div>
                        </form>
                        <hr>
                        <div class="text-end">
                            <button class="btn btn-primary px-5" on:click="{ save }">SAVE</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-5 col-md-6">
                <TransporterVehicles {transporter} on:create="{ onCreateVehicle }" on:edit="{ onEditVehicle }"/>
                <TransporterDrivers {transporter}/>
                <TransporterUsers {transporter}/>
            </div>
        </div>
    {/if}
{/if}
{#if transporterId == -1}
    <PageNotFound message="Transporter not found!"/>
{/if}
